module.exports = __webpack_public_path__ + "9b67a3ceedf424928f3c0a246e79ee38.svg";